module.exports = __webpack_public_path__ + "static/Quicksand-Light-188ca708e4cbbbe3837c3d904b8eeb61.ttf";